import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";
import { FeatureFlagService } from "@dcc/shared/feature-flags/data-access";
import { ConsentClient, UserStore } from "@dcc/vestas-online/data-access";
import { User, VoConsentAgreementSlug, VoConsentPlatformFeatureFlag } from "@dcc/vestas-online/domain";
import { catchError, filter, map, of, retry, switchMap, take } from "rxjs";

export function termsGuard({ redirectTo }: { redirectTo?: any[] } = {}): CanActivateChildFn {
    return () => {
        const featureFlags = inject(FeatureFlagService);
        const userStore = inject(UserStore);
        const consentClient = inject(ConsentClient);
        const router = inject(Router);

        return featureFlags.selectFeaturesEnabled(VoConsentPlatformFeatureFlag).pipe(
            take(1),
            switchMap((consentPlatformEnabled) =>
                userStore.user$.pipe(
                    filter((u): u is User => u !== null),
                    take(1),
                    switchMap((user) =>
                        (consentPlatformEnabled
                            ? consentClient.getRequiredAgreements().pipe(
                                  retry(3),
                                  map((requiredAgreements) => requiredAgreements.some((item) => item.slug === VoConsentAgreementSlug)),
                                  catchError(() => of(true))
                              )
                            : of(!user.termsAccepted)
                        ).pipe(
                            map((requiresTermsAcceptance) => {
                                if (requiresTermsAcceptance) {
                                    return router.createUrlTree(redirectTo ?? ["app", "terms"]);
                                }
                                return true;
                            })
                        )
                    )
                )
            )
        );
    };
}
